import React from 'react'
import HeroSection from './HeroSection'
import { ProductPage } from '../pages/ProductPage'

const ExhibitionPage = () => {
  return (
    <div>
          <HeroSection/>
          <ProductPage/>
    </div>
  )
}

export default ExhibitionPage